const { filter, find, pick } = require('@/plugins/lodash')
import qs from 'qs'
import {
  estimateFeeParamsCreator,
  getMaxStopPointByService,
  getOrderFeeDetail,
  setItemStorage
} from '../plugins/util'

const mixin = {
  methods: {
    $_orderService_setRequirePodByKAProfile(path) {
      const kaProfile = this.$store.getters.kaProfile
      const orderTemplate =
        kaProfile && kaProfile.ro_settings && kaProfile.ro_settings.order_template

      const pickupTemplate = orderTemplate && orderTemplate.pickup
      if (pickupTemplate && path[0]) {
        if (pickupTemplate.require_pop) {
          path[0].require_pop = pickupTemplate.require_pop
        }
        if (pickupTemplate.pop_type) {
          path[0].pop_type = pickupTemplate.pop_type
        }
      }

      const dropoffTemplate = orderTemplate && orderTemplate.dropoff
      if (dropoffTemplate && path && path.length > 0) {
        path.forEach((point, index) => {
          if (index > 0) {
            if (dropoffTemplate.require_pod) {
              point.require_pod = dropoffTemplate.require_pod
            }
            if (dropoffTemplate.pod_type) {
              point.pod_type = dropoffTemplate.pod_type
            }
          }
        })
      }

      return path
    },
    $_orderService_getFormDataParams(customPath) {
      return new Promise((resolve, reject) => {
        const service = this.$store.getters.orderFormService
        if (service && service._id) {
          this.getServiceCod(service._id)
            .then((maxCOD) => {
              var path = customPath || this.$store.getters.orderFormPath
              path = this.$_orderService_setRequirePodByKAProfile(path)

              const requests = this.$store.getters.orderFormRequests
              const images = this.$store.getters.orderFormImages
              const promoCode = this.$store.getters.orderFormPromoCode
              const remarks = this.$store.getters.orderFormRemarks
              const payment_method = this.$store.getters.orderFormPaymentMethod
              const orderTime = this.$store.getters.orderFormOrderTime
              const setOrderTimeAsPickupTime = this.$store.getters.setOrderTimeForPickup
              const token = this.$store.getters.token
              const payload = {
                service,
                path,
                requests,
                images,
                promoCode,
                remarks,
                token,
                payment_method,
                orderTime,
                setOrderTimeAsPickupTime,
                maxCOD
              }

              const params = estimateFeeParamsCreator(payload)
              if (params.order_time === 0) {
                this.$store.dispatch('setOrderFormOrderTime', 0)
              }

              if (params.payment_method !== payment_method) {
                this.$store.dispatch('setOrderPaymentMethod', params.payment_method)
              }

              resolve(params)
            })
            .catch((err) => {
              reject(err)
            })
        } else {
          // console.error('Service is not valid: ', service)
          reject()
        }
      })
    },
    $_orderService_encodeEstimateParams(params) {
      const encodeFields = ['path', 'requests', 'images']
      encodeFields.forEach((prop) => {
        if (params[prop]) params[prop] = JSON.stringify(params[prop])
      })
    },
    $_orderService_getEstimatedFee(customPath, callback) {
      const duration = 200
      const silent = callback && true
      this.$store.dispatch('setOrderFormEstimateFeeTimeout', false)

      if (!silent) {
        this.$store.dispatch('setOrderFormEstimatingFee', true)
      }
      this.$store.dispatch(
        'setOrderFormEstimateFeeTimeout',
        setTimeout(() => {
          this.$_orderService_getFormDataParams(customPath)
            .then((params) => {
              const service = this.$store.getters.orderFormService
              const path = customPath || this.$store.getters.orderFormPath
              const enabledPath = filter(path, (item) => {
                return !item.disabled && item.is_valid
              })
              const max = getMaxStopPointByService(service, this.$store.getters.userProfile)
              const min = service.min_stop_points || 1

              if (service.require_to) {
                if (enabledPath.length < min + 1 || enabledPath.length > max + 1) {
                  if (!silent) {
                    this.$store.dispatch('setOrderFormEstimatedFee', {})
                  }
                  return
                }
              }
              this.$_orderService_estimateFee(params, callback)
            })
            .catch(() => {
              // console.error('$_orderService_getFormDataParams error: ', error)
              this.$store.dispatch('setOrderFormEstimatingFee', false)
            })
        }, duration)
      )
    },

    $_orderService_estimateFee(params, callback) {
      return new Promise((resolve, reject) => {
        const silent = callback && true
        const api = process.env.VUE_APP_API_URL + this.$constants.API.order.estimated_fee

        if (!silent) {
          this.$store.dispatch('setOrderFormEstimatedFee', {})
          this.$store.dispatch('setOrderFormEstimatingFee', true)
        }
        this.axios({
          method: 'POST',
          url: api,
          timeout: 20000,
          headers: this.$constants.HTTP_REQUEST.HEADERS,
          data: qs.stringify(params)
        })
          .then((response) => {
            if (silent) {
              let estimatedFee = response && response.data
              callback(estimatedFee)
              resolve(estimatedFee)
            } else {
              if (response && response.data) {
                let estimatedFee = response && response.data
                this.$_orderService_updateEstimatedFee(estimatedFee)
                this.$store.dispatch('setOrderFormEstimatedFee', estimatedFee)
                resolve(estimatedFee)
              } else {
                this.$store.dispatch('setOrderFormEstimateFeeError', new Error('no response data'))
                this.$sentry.appCaptureException(
                  new Error(
                    `Estimate Fee Error: ${JSON.stringify(response || 'no response data')}`
                  ),
                  'Estimate Fee'
                )
                reject(new Error('no response data'))
              }
            }
          })
          .catch((error) => {
            this.$sentry.appCaptureException(
              new Error(`Estimate Fee Error: ${JSON.stringify(error.response || error)}`),
              'Estimate Fee'
            )
            if (silent) {
              callback(error)
              reject(error)
            } else {
              const response = error && error.response
              if (
                response &&
                response.status === 404 &&
                response.data.title === 'Token not found'
              ) {
                this.$cookie.delete(this.$constants.COOKIE_NAME__TOKEN)
                this.$cookie.delete(this.$constants.COOKIE_NAME__TOKEN, {
                  domain: this.$_VUE_APP_DOMAIN
                  // process.env.VUE_APP_DOMAIN
                })

                return this.$store.dispatch('signOut').then(() => {
                  const msg = this.$t('estimated_fee.token_expired')
                  this.$store.dispatch('setSnackbar', {
                    visible: true,
                    title: msg,
                    color: 'error',
                    timeout: 3000
                  })
                  this.$_orderService_getEstimatedFee()
                })
              } else if (
                response &&
                response.status === 406 &&
                response.data.title === this.$t('invalid_delivery_area')
              ) {
                const pathParsed = JSON.parse(params.path)
                const trackData = pathParsed.map((p) => {
                  return pick(p, ['lat', 'lng', 'short_address', 'mobile'])
                })
                this.$analyticTracking.logEvent(
                  this.$trackingEvents.ACTIONS.CLICK,
                  this.$trackingEvents.EVENTS.NEWORDER_SELECT_LOCATION_FAIL,
                  {},
                  undefined,
                  {
                    path: JSON.stringify(trackData),
                    service_id: params.service_id
                  }
                )
              } else if (response && (response.status === 503 || response.status === 500)) {
                this.$_globalMixin_requestErrorHandle(response)
              }

              this.$store.dispatch('setOrderFormEstimateFeeError', error)
              reject(error)
            }
          })
      })
    },
    $_orderService_updateEstimatedFee(estimatedFee) {
      if (estimatedFee) {
        const feeDetail = getOrderFeeDetail(estimatedFee)
        if (feeDetail.distance_fee >= 0) {
          Object.assign(estimatedFee, feeDetail)
        }
      }
      return estimatedFee
    },
    getServiceCod(serviceId) {
      return new Promise((resolve) => {
        const serviceDetail = find(this.$store.getters.serviceTypes, {
          _id: serviceId
        })
        // console.log('serviceDetail', serviceDetail)
        if (serviceDetail) {
          const maxCOD = serviceDetail.cod
          resolve(maxCOD)
        } else {
          const api = `${process.env.VUE_APP_API_URL}${this.$constants.API.order.service_detail}?format=json&service_id=${serviceId}`
          this.axios
            .get(api)
            .then((response) => {
              const service = response.data
              const maxCOD = (service && service.cod) || undefined
              resolve(maxCOD)
            })
            .catch(() => {
              resolve()
            })
        }
      })
    },
    $_orderService_createOrder() {
      return new Promise((resolve, reject) => {
        this.$store.dispatch('setOrderFormCreatingOrder', true)
        this.$_orderService_getFormDataParams()
          .then((params) => {
            const estimatedFee = this.$store.getters.orderFormEstimatedFee
            if (!estimatedFee.discount || estimatedFee.discount === 0) {
              delete params.promo_code
            }
            params.total_pay = estimatedFee.total_pay
            if (params.payment_method) {
              setItemStorage(
                this.$constants.LOCAL_STORAGE_KEY__LATEST_PAYMENT_METHOD,
                params.payment_method
              )
            }

            const api = process.env.VUE_APP_API_URL + this.$constants.API.order.create
            this.axios({
              method: 'POST',
              url: api,
              timeout: this.$constants.HTTP_REQUEST.TIMEOUT,
              headers: this.$constants.HTTP_REQUEST.HEADERS,
              data: qs.stringify(params)
            })
              .then((response) => {
                this.$store.dispatch('setOrderFormCreatingOrder', false)
                if (response && response.data) {
                  resolve(response.data)
                  this.$store.dispatch('resetOrderForm')
                  this.$store.dispatch('resetOrders')
                } else {
                  reject(new Error('no response data'))
                }
              })
              .catch((e) => {
                this.$store.dispatch('setOrderFormCreatingOrder', false)
                this.$sentry.appCaptureException(
                  new Error(
                    `Create Order Error: est_ttp: ${estimatedFee.total_pay} ${JSON.stringify(
                      e.response || e
                    )}`
                  ),
                  'Create Order'
                )
                reject(e)
              })
            this.$analyticTracking.logEvent(
              this.$trackingEvents.ACTIONS.CLICK,
              this.$trackingEvents.EVENTS.NEW_ORDER_PURCHASE,
              params
            )
          })
          .catch((error) => {
            console.error('$_orderService_getFormDataParams error: ', error)
          })
      })
    }
  }
}

export default mixin
